import personalRecommendations from '@/js/services/api/personalRecommendations';

const NAME_PROP = 'book24-saved-reco';
const NAME_PROP_DATE = 'book24-saved-reco-date';
// 20 минут
const INTERVAL = 1000 * 60 * 20;
// 1 минута
const DELAY_TIMER = 1000 * 60;

const getAuthStatus = () => {
  const html = document.querySelector('html');
  return Boolean(html.dataset.authorized);
};

const saveListId = (list = []) => {
  localStorage.setItem(NAME_PROP, list.toString());
};

const saveDate = () => {
  const date = new Date();
  localStorage.setItem(NAME_PROP_DATE, date.toString());
};

export const getDateSave = () => localStorage.getItem(NAME_PROP_DATE);

export const getListSave = () => {
  const saveResult = localStorage.getItem(NAME_PROP);

  if (saveResult) {
    try {
      return saveResult.split(',');
    } catch (e) {
      return [];
    }
  }
  return [];
};

const getRecoProducts = async () => {
  await personalRecommendations({
    recoType: 'reco_kk',
    pageSize: 100,
  })
    .then(({ list }) => {
      saveListId(list.map(item => item.id));
      saveDate();
    })
    .catch(() => {
      saveListId([]);
      saveDate();
    });
};

const setTimer = () => {
  let timer = null;
  timer = setTimeout(async function run() {
    const lastDate = getDateSave();
    const currentDate = new Date();
    const diffTime = lastDate ? ((currentDate - new Date(lastDate)) / INTERVAL) : 0;

    if (diffTime > 1) {
      await getRecoProducts();
      clearTimeout(timer);
    }
    timer = setTimeout(run, DELAY_TIMER);
  }, 0);
};

export const saveRecoInit = async () => {
  if (getAuthStatus()) {
    const date = getDateSave();
    const savedResult = getListSave();
    if (!savedResult.length || !date) {
      await getRecoProducts();
      setTimer();
    } else {
      setTimer();
    }
  }
};
